<template>
  <div class="c-o-my-pages-section c-o-my-pages-section--bg-gray">
    <div class="c-o-my-pages-section__inner">
      <div class="c-o-my-pages-section__message" v-if="errorMessages.length > 0">
        <message type="error">
          <div class="o-wysiwyg">
            <ul>
              <li v-for="(message, index) in errorMessages" :key="`message-${index}`">{{message}}</li>
            </ul>
          </div>
        </message>
      </div>
      <div class="o-wysiwyg u-margin-bottom-1">
        <h2 class="c-o-my-pages-section__heading">Presentation</h2>
        <p>Här kan ni skriva den presentation som syns utåt och representerar ert företag på brabyggare.se. En välskriven presentation ökar era chanser att få fler och bättre förfrågningar.</p>
      </div>
      <div class="c-o-my-pages-section__form">
        <div class="c-o-my-pages-section__form-block">
          <image-upload
            v-model="image"
            title="Presentationsbild:"
            name="Presentation"
            info="Visas på er presentation och i listningar."
            :id="company.Id"
          ></image-upload>
        </div>
        <div class="c-o-my-pages-section__form-block">
          <input-area
            v-model="presentation"
            :label="'Presentationstext:'"
            :info="'Visas på er presentation och i listningar.'"
            :rows="10"
          ></input-area>
        </div>
      </div>
      <div class="c-o-my-pages-section__save-button">
        <success-button :currentState="saveState" @buttonClicked="save"></success-button>
      </div>

      <div class="o-wysiwyg">
        <h3 class="c-o-my-pages-section__heading c-o-my-pages-section__heading--margin-top">HTML-presentation</h3>
        <p>Utöver en presentationstext så finns det möjlighet att addera en presentation som innehåller element såsom formaterad text, bilder eller film. Vill du använda detta alternativ vänligen hör av dig till oss så hjälper vi dig!</p>
        <p class="c-o-my-pages-section__sub-heading">Presentation:</p>
        <div class="c-o-company-section__body" v-if="presentationHtml" v-html="presentationHtml"></div>
        <div class="c-o-company-section__body" v-else><i>Det finns ingen HTML-presentation.</i></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

import {
  UPDATE_COMPANY_DATA,
  SAVE_COMPANY_PRESENTATION,
  GET_SAVE_ERROR
} from "../../../../../../store/store-models/my-pages-company-model";

import { timeout } from "../../../../../../helpers";

import InputArea from "../../../../atoms/form/AtomTextarea.vue";
import SuccessButton from "../../../../atoms/AtomSuccessButton.vue";
import ImageUpload from "../../../../atoms/form/AtomImageUpload.vue";
import Message from "../../../../molecules/MoleculeMessage.vue";

export default {
  props: ["company"],
  components: {
    InputArea,
    SuccessButton,
    ImageUpload,
    Message
  },
  data() {
    return {
      errorMessages: [],
      file: null,
      saveState: "default"
    };
  },
  computed: {
    saveError: function() {
      return this.$store.getters[GET_SAVE_ERROR]("presentation");
    },
    image: {
      get() {
        return this.company.Image;
      },
      set(value) {
        this.file = value;
        if (value == null)
          this.$store.dispatch(UPDATE_COMPANY_DATA, { Image: null });
      }
    },
    presentation: {
      get() {
        return this.company.Presentation;
      },
      set(value) {
        this.$store.dispatch(UPDATE_COMPANY_DATA, { Presentation: value });
      }
    },
    presentationHtml: function() {
      return this.company.PresentationHtml;
    }
  },
  methods: {
    ...mapActions({
      saveCompanyPresentation: SAVE_COMPANY_PRESENTATION
    }),
    async save() {
      this.errorMessages = [];
      this.saveState = "processing";

      try {
        const mainResult = await this.saveCompanyPresentation(this.file);
        this.saveState = "success";
      } catch (e) {
        this.errorMessages.push(this.saveError);
        this.saveState = "error";
      }

      await timeout();
      this.saveState = "default";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/profile/OrganismMyPagesPresentation.vue